import React from 'react';

import { Outlet } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';

import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

import logo from '../logo.svg';

import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';
import Footer from './Footer';
import { NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const FAST_URL = process.env.REACT_APP_DS_API_URL

export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const username = accounts[0] && accounts[0].name;
    const EXPORT_URL = FAST_URL + '/_export'
    
    return (
        <>
            <Container>
                <Navbar bg="bg-white" expand="lg" className="py-3 mb-4 border-bottom">
                    <Navbar.Brand href={process.env.REACT_APP_DS_HOME}>
                        <img width="125px" height="50px" src={logo} alt="CNM Universal Themes Assessment" />
                        <span className="fs-4 px-3">Universal Themes Assessment</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse>
                        <Nav className="me-auto">
                            { isAuthenticated 
                                ?
                                <NavDropdown title="Tools" id="tools-nav-dropdown">
                                    <LinkContainer to="dashboard">
                                        <NavDropdown.Item href="dashboard">
                                            Dashboard
                                        </NavDropdown.Item>
                                    </LinkContainer>
                                    
                                        <NavDropdown.Item href={EXPORT_URL}>
                                            Export
                                        </NavDropdown.Item>
                                    
                                </NavDropdown>
                                :
                                <></>
                            }
                            <NavDropdown title="Reports" id="data-nav-dropdown">
                                <Dropdown.ItemText>FAsT Static Site</Dropdown.ItemText>
                                <Dropdown.Divider />
                                <NavDropdown.Item href={process.env.REACT_APP_DS_STATIC_HOME}>2020-2021</NavDropdown.Item>
                                <NavDropdown.Item href={process.env.REACT_APP_DS_STATIC_HOME}>2021-2022</NavDropdown.Item>
                                <NavDropdown.Item href={process.env.REACT_APP_DS_STATIC_HOME}>2022-2023</NavDropdown.Item>
                            </NavDropdown>  

                            { isAuthenticated 
                                ?
                                <NavDropdown title="Help" id="help-nav-dropdown">
                                    <NavDropdown.Item 
                                        href="https://rise.articulate.com/share/_xKJgBYqG_3uugKY8h92SOJYGICSk7v8"
                                        target="_blank">
                                        Assessment Help
                                    </NavDropdown.Item>
                                </NavDropdown>
                                :
                                <></>
                            }
                        </Nav>
                        { username
                            ? <Nav className="justify-content-end">
                                 Signed in as {username}
                             </Nav>
                            : null
                        }
                        &nbsp;
                        &nbsp;
                        <Nav className="justify-content-end">
                            <>
                            { isAuthenticated
                                ? <SignOutButton />
                                : <SignInButton />
                            }
                            </>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
            
            <div className="container">
                
                    <Outlet />
                
                


                <div className="p-5" />
                <Footer />
            </div>
        </>
    )
}